import React from 'react';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import HistoryDriverSelectBottomSheet from '@di-shared/features/history/filter/HistoryDriverSelectBottomSheet';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 500;

export default function HistoryDriverSelectPage() {
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <HistoryDriverSelectBottomSheet />
    </BottomSheetWebViewWrapper>
  );
}
